import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as accountActions from '../actions/account/account';
import basketActions from '../actions/transactions/basket';
import notificationActions from '../actions/notifications/notifications';
import { Loader } from "../components/common/elements";

//Components
import Logo from '../components/dashboardNew/objects/Logo';
import Anchor from "../components/dashboardNew/objects/Anchor";

// images
import {Icon} from 'in-touch-icons';


class Header extends Component {

	constructor() {
		super();
		this.state = {
			isSelected: false,
			windowWith: window.innerWidth,
			type: '',
			profilePicture: null,
			hoverOut: false
		}
	}

	// toggle class on body for mobile nav
	mobileNavActive = () => document.body.classList.toggle('mobile-nav-active');


	componentWillMount() {
    if(!this.props.pathname.includes('expired')
      && !this.props.pathname.includes('login')
      && !this.props.pathname.includes('logout')) {
      if (this.isFreeMember()) {
        browserHistory.push('/expired');
			}
		}
  }
	  
  componentWillUpdate(nextProps){
	  if(this.props.pathname !== nextProps.pathname)
	  {
		  this.setState({
			  isSelected: false
		  })
	  }
  }

	componentDidMount() {

        const personId = localStorage.getItem('person_id');

		const { getMessageNotifications, getBasket } = this.props;

		fetch(`https://s3.intouchnetworks.com/getImage.php?id=${ personId }`)
			.then( response => response.text() )
			.then( formatted => this.setState({ profilePicture : formatted }) );

        personId && getBasket();
        personId && getMessageNotifications();
	};

    componentDidUpdate() {
        if(!this.props.pathname.includes('expired')
            && !this.props.pathname.includes('login')
            && !this.props.pathname.includes('logout')) {
            if (this.isFreeMember()) {
                browserHistory.push('/expired');
            }
		}
    }

    isFreeMember = () => {
        return localStorage.getItem('free_account') !== null &&
            localStorage.getItem('token') !== null &&
            localStorage.getItem('free_account') === 1 ||
            localStorage.getItem('free_account') === "1";
    };

    shouldReturnNav = () => {
		const pathname = this.props.pathname;
		if( ( pathname.includes('login') ) || 
			( !!localStorage.token && this.isFreeMember() ) ||
			( !localStorage.token &&  (pathname.includes('privacy') || pathname.includes('cookies') || pathname.includes('terms') ) ) ) {
            return null;
        } else return <Header history={ history } />
	};
	
	basket(){
		if( !this.props.basket.products.length && !this.props.basket.packages.length ){ return };
		return <Anchor internal path='/basket' anchorClass='header-link basket'><Icon iconName='basket' /></Anchor>;
	}

	render () {
		if( !this.props.basket ){ return <Loader /> };

		// Message count doesn't work
		// let messageCount;
		//
		// if( this.props.messages.length > 0 ) {
		// 	messageCount = 'active';
		// } else {
		// 	messageCount = '';
		// }

		return (
			<header className="main-header">
				<Logo logo='logoLight' altText='In Touch Networks logo' logoClass='logo-image' path='/'/>
				<div className="header-links-wrapper">
					{ this.basket() }
					<Anchor internal path='/account/basic' anchorClass='header-link settings-link'>
						<Icon iconName='settings' />
					</Anchor>
					<Anchor target path='https://intouchnetworks.zendesk.com/hc/en-gb ' anchorClass="header-link help-icon">
						<img className="icon-itn help-image" src="/images/icons-new/help.svg" alt="help icon" />
					</Anchor>
					<Anchor internal path='/logout' anchorClass='theme-button'>
						Logout
					</Anchor>
					<button className="burger-button" onClick={ this.mobileNavActive }>
						<span className="burger-span"></span>
						<span className="burger-span"></span>
						<span className="burger-span"></span>
					</button>
				</div>
			</header>
		);
	}
}

const mapStateToProps = state => ({
	basket		: state.transactions.basket,
	hasErrored	: state.authentication.error.hasErrored,
	errorCode	: state.authentication.error.errorCode,
	messages	: state.notifications.messages,
});

const mapDispatchToProps = dispatch => ({
	getBasket				: () => dispatch( basketActions.getBasket() ),
	getMessageNotifications	: () => dispatch( notificationActions.getMessageNotifications() ),
});

export default connect( mapStateToProps, mapDispatchToProps )( Header );



// WEBPACK FOOTER //
// src/client/layouts/Header.js